import {Validators} from '@angular/forms';

import {
    IndividualFilterModel,
    IndividualReportModel,
} from '@spa/api';

import {ComponentTypesEnum, UnspecifiedKeysEnum} from '../../app/shared/enums';
import {FilterControlInterface} from '../../app/shared/interfaces';
import {AutocompleteControl, BaseControl, Helper, SelectControl} from '../../app/shared/classes';
import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from '../../app/shared/components';

import {EnrollTypesEnum} from '../../app/entries/panel/enums';

export const EnrollDateSelector = 'enrollDate';
export const PanelLeadsStorageId = 'PanelLeadsComponent';
export const PanelLeadsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: EnrollDateSelector,
            placeholder: 'Enroll date',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getEnrollDateFromSelector(),
                    value: null,
                    placeholder: 'Enroll date from',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: IndividualFilterModel.getEnrollDateToSelector(),
                    value: null,
                    placeholder: 'Enroll date to',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 1,
        },
        {
            name: IndividualFilterModel.getEnrollTypeSelector(),
            placeholder: 'Client Type',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getEnrollTypeSelector(),
                    value: EnrollTypesEnum.All,
                    placeholder: 'Client Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.All),
                            value: EnrollTypesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Individual),
                            value: EnrollTypesEnum.Individual
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Corporate),
                            value: EnrollTypesEnum.Corporate
                        },
                    ]
                })
            ],
            sortIndex: 3
        },
        {
            name: IndividualFilterModel.getNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [Validators.minLength(3)],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 4,
        },
        {
            name: IndividualFilterModel.getEmailSelector(),
            placeholder: 'Email',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getEmailSelector(),
                    value: null,
                    placeholder: 'Email',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 5,
        },
        {
            name: IndividualFilterModel.getCountryIdSelector(),
            placeholder: 'Country',
            controls: [
                new AutocompleteControl({
                    name: IndividualFilterModel.getCountryIdSelector(),
                    value: null,
                    placeholder: 'Country',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: []
                })
            ],
            sortIndex: 6
        },
        {
            name: IndividualFilterModel.getEnrollPortalIdsSelector(),
            placeholder: 'Portal',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getEnrollPortalIdsSelector(),
                    value: UnspecifiedKeysEnum.UnspecifiedPortalIdKey,
                    placeholder: 'Portal',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedPortalIdKey
                        }
                    ]
                })
            ],
            sortIndex: 7
        }
    ];
};

export const PanelLeadsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: IndividualReportModel.getStatusNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEmailSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getCountryNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollPortalNameSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const PanelLeadsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Enroll Date',
                selector: IndividualReportModel.getEnrollDateSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: IndividualReportModel.getStatusNameSelector()
            }),
            new ReportTableColumn({
                label: 'Client Type',
                selector: IndividualReportModel.getEnrollTypeSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: IndividualReportModel.getNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: IndividualReportModel.getEmailSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Country',
                selector: IndividualReportModel.getCountryNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Portal',
                selector: IndividualReportModel.getEnrollPortalNameSelector()
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};
